import { baseApi } from './baseApi';

const componentApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    // hero slide component
    getHeroSlide: build.query({
      query: () => ({
        url: '/components/get-all-hero-slides',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetHeroSlideQuery } = componentApi;
